import CatracasService from '../../../services/catracas/catracasService';
const api = new CatracasService()
const state = {
  solicitacoes:[],
  solicitacoes_loading:false,
};
const getters = {
  StateSolicitacoes: state => state.solicitacoes,
  StateSolicitacoesLoading: state => state.solicitacoes_loading,
};
const mutations = {
  SetSolicitacoes(state, value){state.solicitacoes = value},
  SetSolicitacoesLoading(state, value){state.solicitacoes_loading = value},
};
const actions = {
    async GetSolicitacoesVisitantes({commit}, params) {
      commit('SetSolicitacoesLoading', true)
      try{
          let response = await api.list_solicitacao_visitantes(params)
          commit('SetSolicitacoes', response.data.results)
        }catch(error){
          commit('SetSolicitacoes', [])
          if (error.response && error.response.status === 404){
            commit("setAlerts", [ {
              message: 'Nenhuma solicitação encontrada!',
              tag: 'warn',
              timeout: '4000',
              title: 'Nada encontrado'
            } ])
          }else{
            commit("setAlerts", [ error.toast_message ])
          }
      }
      commit('SetSolicitacoesLoading', false)
    },
    async CreateSolicitacaoVisitante({commit}, data) {
      commit('SetSolicitacoesLoading', true)
      try{
        let response =  await api.post_solicitacao_visitante(data)
        commit("setAlerts", [ {
          message: `Solicitação realizada com sucesso!`,
          tag: 'success',
          timeout: '8000',
          title: 'Solicitação de cadastro de Visitante'
        } ])
        commit('SetSolicitacoesLoading', false)
        return response
      }catch(error){
        commit('SetSolicitacoesLoading', false)
        if (error.response){
          commit("setAlerts", [ {
            message: `${error.response.status} - Falha ao solicitar cadastro!`,
            tag: 'error',
            timeout: '10000',
            title: error.response.data
          } ])
          console.error('Error in CreateSolicitacaoVisitante',error.response)
        }
        return error.response
      }
    },
    async UpdateSolicitacaoVisitante({commit}, data) {
      commit('SetSolicitacoesLoading', true)
      try{
        let response =  await api.update_solicitacao_visitante(data, data.id)
        commit("setAlerts", [ {
          message: `Solicitação atualizada com sucesso!`,
          tag: 'success',
          timeout: '8000',
          title: 'Solicitação de cadastro de Visitante'
        } ])
        commit('SetSolicitacoesLoading', false)
        return response
      }catch(error){
        commit('SetSolicitacoesLoading', false)
        if (error.response){
          commit("setAlerts", [ {
            message: `${error.response.status} - Falha ao atualizar solicitação!`,
            tag: 'error',
            timeout: '10000',
            title: error.response.data
          } ])
          console.error('Error in UpdateSolicitacaoVisitante',error.response)
        }
        return error.response
      }
    },
    async DeleteSolicitacaoVisitante({commit}, id) {
      commit('SetSolicitacoesLoading', true)
      try{
        let response =  await api.delete_solicitacao_visitante(id)
        commit("setAlerts", [ {
          message: `Solicitação removida com sucesso!`,
          tag: 'success',
          timeout: '8000',
          title: 'Solicitação de cadastro de Visitante'
        } ])
        commit('SetSolicitacoesLoading', false)
        return response
      }catch(error){
        commit('SetSolicitacoesLoading', false)
        if (error.response){
          commit("setAlerts", [ {
            message: `${error.response.status} - Falha ao remover solicitação!`,
            tag: 'error',
            timeout: '10000',
            title: error.response.data
          } ])
          console.error('Error in DeleteSolicitacaoVisitante',error.response)
        }
        return error.response
      }
    },
    async GetParametroStatusMatricula({ commit }, params) {
      try{
        let response = await api.lista_parametro_status_matricula(params)
        return response.data.results
      }catch(error){
        if (error.response && error.response.status === 404){
          commit("setAlerts", [ {
            message: 'Falha ao obter os Parâmetros de Status de Matrícula!',
            tag: 'warn',
            timeout: '10000',
            title: 'Ops'
          } ])
        }
        return []
      }
    },
    async UpdateParametroStatusMatricula({commit}, data) {
      try{
        let response =  await api.update_parametro_status_matricula(data, data.id)
        return response
      }catch(error){
        if (error.response){
          commit("setAlerts", [ {
            message: `${error.response.status} - Falha ao atualizar parâmetro!`,
            tag: 'error',
            timeout: '10000',
            title: error.response.data
          } ])
          console.error('Error in UpdateParametroStatusMatricula',error.response)
        }
        return error.response
      }
    },
    async GetLogVisitante({commit}, id) {
      commit('SetIDSecureVisitantesLoading', true)
      try{
        let response =  await api.get_log_visitante(id)
        commit('SetIDSecureVisitantesLoading', false)
        return response
      }catch(error){
        commit('SetIDSecureVisitantesLoading', false)
        if (error.response){
          commit("setAlerts", [ {
            message: `${error.response.status} - Falha ao carregar Logs do Visitante!`,
            tag: 'error',
            timeout: '7000',
            title: error.response.data
          }])
          console.error('Error in GetLogVisitante',error.response)
        }
        return error.response
      }
    },
  };
export default {
  state,
  getters,
  actions,
  mutations
};